import { memo } from 'react';

import { Card } from "primereact/card";
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';

import { useReport } from "../../context/report";

export default memo(function Rolo() {
    const { data } = useReport();

    let array = ["batidas", "eficiencia_tear", "metros", "manual", "trama", "trama_cmpx", "urdume_cmpx", "total_cmpx", "total", "urdume"]
    let somas = { "tipo": "Total" }
    let medias = { "tipo": "Média" }

    array.forEach((campo) => {
        let soma = 0;
        let count = 0;
        data.forEach((item) => {
            somas[campo] = somas[campo] ? somas[campo] + parseFloat(item[campo]) : parseFloat(item[campo]);
            if(parseFloat(item[campo]) > 0) {
                soma += parseFloat(item[campo]);
                count += 1;
            }
        });
        somas[campo] = Math.round(somas[campo]);
        medias[campo] = count > 0 ? (soma / count).toFixed(2) : 0;
        if(campo === "batidas") 
            medias[campo] = parseInt(medias[campo]);
    })

    return (
        <div>
            <Card className='p-mb-2' title="Geral">
                <DataTable
                    responsiveLayout='scroll'
                    size='small'
                    value={[somas, medias]}
                >
                    <Column header="Tipo" field='tipo' />
                    <Column header="Passadas" field='batidas' />
                    <Column header="Eficiência" field="eficiencia_tear" />
                    <Column header="(m)" field='metros'/>
                    <Column header="Trama" field='trama' />
                    <Column header="Urdume" field='urdume' />
                    <Column header="Manual" field='manual' />
                    <Column header="Tr. CMPX" field='trama_cmpx' />
                    <Column header="Ur. CMPX" field='urdume_cmpx' />
                    <Column header="Total" field='total' />
                    <Column header="Total CMPX" field='total_cmpx' />
                </DataTable>
            </Card>

            <DataTable  
                responsiveLayout='scroll'
                size='small'
                value={data}
            >
                <Column header="Tear" field='tear' sortable/>
                <Column header="Turma" field='turma' sortable />
                <Column header="Data" field='data_formatada' />
                <Column header="Rolo" field='rolo' />
                <Column header="Rolada" field='rolada' />
                <Column header="Passadas" field='batidas' />
                <Column header="Eficiência" field="eficiencia_tear" sortable />
                <Column header="(m)" field='metros' sortable/>
                <Column header="Trama" field='trama' sortable />
                <Column header="Urdume" field='urdume' sortable />
                <Column header="Manual" field='manual' sortable />
                <Column header="Tr. CMPX" field='trama_cmpx' sortable />
                <Column header="Ur. CMPX" field='urdume_cmpx' sortable />
                <Column header="Total" field='total' sortable />
                <Column header="Total CMPX" field='total_cmpx' sortable />
            </DataTable>

        </div>
    )
});